export const LANGS = [
  { code: "pl", label: "PL" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
];

export const translations = {
  pl: {
    nav: { quiz: "Quiz", offer: "Możliwości", fleet: "Flota", about: "O nas", how: "Jak to działa", faq: "FAQ" },
    header: { descriptor: "Praktyczne spotkania z dronami", cta: "Sprawdź, czy to dla Ciebie", ctaFull: "Sprawdź, czy latanie dronem jest dla Ciebie" },
    hero: {
      overline: "DRON • bezpieczne latanie",
      title: "Naucz się latać dronem i odkryj nowe możliwości 🚀",
      subtitle: "Podczas pierwszego spotkania zobaczysz, jak wygląda bezpieczne sterowanie dronem i od czego zacząć — nawet jeśli nigdy nie trzymałeś kontrolera w rękach.",
      cta: "Sprawdź, czy latanie dronem jest dla Ciebie →",
      channelCta: "Dołącz do naszego kanału i śledź, kiedy będzie organizowany następny event z darmowym lataniem",
      badges: ["Zaczynasz od zera", "Nie musisz mieć własnego drona", "Uprawnienia A1/A3 i bezpieczeństwo"],
      scroll: "Przewiń do możliwości",
    },
    opportunities: {
      overline: "Więcej niż pierwszy lot",
      title: "Co możesz zyskać, ucząc się latać dronem?",
      intro: "Jedna nowa umiejętność może otworzyć zupełnie nową perspektywę — dla Twojej kreatywności, pewności siebie i przyszłości.",
      cards: [
        { id: "create", title: "TWÓRZ", text: "Twórz zdjęcia i filmy z zupełnie nowej perspektywy. Naucz się tworzyć spektakularne ujęcia z powietrza, których nie da się zrobić zwykłym aparatem." },
        { id: "grow", title: "ROŚNIJ", text: "Zdobądź umiejętność przyszłości. Drony są wykorzystywane w coraz większej liczbie branż — od produkcji wideo po inspekcje i pomiary." },
        { id: "professional", title: "WYKORZYSTAJ ZAWODOWO", text: "Odkryj nowe możliwości kariery. Poznaj sposoby wykorzystania dronów w pracy, biznesie i projektach kreatywnych." },
        { id: "experience", title: "PRZEŻYJ COŚ NOWEGO", text: "Poczuj emocje podczas pierwszego samodzielnego lotu. Nie potrzebujesz doświadczenia — zaczynasz od zera, z osobą prowadzącą spotkanie obok." },
      ],
    },
    confidence: {
      overline: "Bez barier na starcie",
      title: "Nie potrzebujesz niczego, by zacząć",
      items: [
        { id: "beginner", title: "Nigdy nie latałeś?", text: "Zaczynamy od podstaw." },
        { id: "equipment", title: "Nie masz drona?", text: "Zapewniamy cały sprzęt." },
        { id: "safety", title: "Boisz się rozbić?", text: "Osoba z uprawnieniami jest obok podczas pierwszych ćwiczeń." },
        { id: "rules", title: "Nie znasz zasad?", text: "Pokażemy Ci, jak latać bezpiecznie i odpowiedzialnie." },
      ],
    },
    quiz: {
      overline: "Szybki quiz",
      title: "Czy pilotaż dronów jest dla Ciebie?",
      subtitle: "Odpowiedz na 4 krótkie pytania i odkryj, co możesz osiągnąć, ucząc się latać dronem. Na końcu zobaczysz, jak może wyglądać Twoje pierwsze spotkanie.",
      start: "Rozpocznij quiz →",
      back: "Wstecz",
      next: "Następne pytanie →",
      restart: "Zacznij od nowa",
      progress: "Pytanie",
      questions: [
        { id: "motivation", title: "Dlaczego chcesz nauczyć się latać dronem?", options: [
          { id: "try", text: "Chcę spróbować czegoś nowego" },
          { id: "content", text: "Chcę tworzyć zdjęcia i filmy z powietrza" },
          { id: "career", text: "Chcę zdobyć przydatną umiejętność zawodową" },
          { id: "explore", text: "Jeszcze nie wiem — chcę po prostu sprawdzić możliwości" },
        ] },
        { id: "experience", title: "Czy latałeś już kiedyś dronem?", options: [
          { id: "never", text: "Nigdy" },
          { id: "few", text: "Kilka razy" },
          { id: "improve", text: "Tak, ale chcę poprawić swoje umiejętności" },
        ] },
        { id: "barrier", title: "Co najbardziej Cię powstrzymuje?", options: [
          { id: "crash", text: "Boję się rozbić drona" },
          { id: "control", text: "Nie wiem, jak nim sterować" },
          { id: "rules", text: "Nie rozumiem przepisów i zasad" },
          { id: "doubt", text: "Nie jestem pewien, czy dam radę" },
        ] },
        { id: "outcome", title: "Co chcesz osiągnąć dzięki tej umiejętności?", options: [
          { id: "content", text: "Tworzyć niesamowite materiały wideo" },
          { id: "confidence", text: "Nauczyć się latać pewnie" },
          { id: "career", text: "Zdobyć nowoczesną umiejętność zawodową" },
          { id: "experience", text: "Po prostu przeżyć coś ekscytującego i nowego" },
        ] },
      ],
      result: {
        overline: "Twój wynik",
        intro: "Na podstawie Twoich odpowiedzi wskazaliśmy najlepszy pierwszy krok dla Ciebie.",
        benefits: ["Poznasz podstawy sterowania dronem", "Wykonasz pierwsze ćwiczenia w locie", "Przekonasz się, że możesz nauczyć się latać od zera", "Dowiesz się, jakie możliwości otwiera ta umiejętność"],
        firstMeeting: "Pierwsze spotkanie pomoże Ci zdecydować, co dalej.",
        profiles: {
          create: { title: "Możesz tworzyć coś naprawdę wyjątkowego 🚀", text: "Pilotaż dronów pomoże Ci zamienić pomysły w obrazy i historie, które się wyróżniają." },
          career: { title: "Ta umiejętność może otworzyć nowe możliwości zawodowe 💼", text: "Poznasz sposoby wykorzystania dronów w mediach, marketingu, nieruchomościach i wielu innych branżach." },
          confidence: { title: "Możesz nauczyć się latać pewnie i bezpiecznie 🧠", text: "Dobre wskazówki pomogą Ci zamienić niepewność w bezpieczne i odpowiedzialne sterowanie." },
          explore: { title: "Pilotaż dronów może być Twoją nową pasją 🔥", text: "Pierwszy lot to prosty sposób, by odkryć umiejętność, którą możesz później rozwijać." },
        },
      },
      form: {
        title: "Umów pierwsze spotkanie",
        name: "Imię",
        contact: "Telefon lub Telegram",
        city: "Miasto",
        consentPre: "Akceptuję ",
        consentLink: "politykę prywatności",
        placeholderName: "Twoje imię",
        placeholderContact: "+48 501 254 893 lub @nazwa",
        placeholderCity: "Warszawa",
        submit: "🔥 Umów pierwsze spotkanie",
        sending: "Wysyłanie…",
        successTitle: "Twój pierwszy krok jest zarezerwowany!",
        successText: "Wkrótce skontaktujemy się z Tobą, aby ustalić szczegóły pierwszego spotkania.",
        error: "Coś poszło nie tak. Spróbuj ponownie.",
        validation: { name: "Podaj imię.", contact: "Podaj numer telefonu lub nazwę użytkownika Telegrama.", city: "Podaj miasto.", consent: "Zaakceptuj politykę prywatności.", turnstile: "Potwierdź, że nie jesteś botem." },
      },
    },
    offer: {
      overline: "Pierwsze spotkanie",
      title: "Zobacz, jak wygląda latanie dronem",
      intro: "Podczas pierwszego spotkania pokażemy Ci podstawy bezpiecznego sterowania i odpowiemy na pytania o dalszą naukę.",
      badgeTop: "A1 / A3",
      badgeBottom: "bezpieczne podejście",
      items: [
        { title: "Zasady bezpieczeństwa", text: "Poznasz najważniejsze zasady odpowiedzialnego latania i przygotowania do startu." },
        { title: "Poznaj aparaturę", text: "Zobaczysz, jak działa kontroler i jak prawidłowo przygotować drona do lotu." },
        { title: "Pierwsze ćwiczenia", text: "Spróbujesz podstawowych manewrów i spokojnego lądowania z osobą prowadzącą obok." },
        { title: "Co dalej?", text: "Porozmawiamy o tym, jak rozwijać umiejętności i wykorzystywać drony w praktyce." },
      ],
    },
    fleet: {
      overline: "Nasza flota",
      title: "Na czym latamy: nasz sprzęt",
      cards: [
        { badge: "Rekreacyjne", desc: "Idealne na start przygody z dronami. Sterowanie gestami, telefonem lub kontrolerami DJI. Świetne do podróży i vlogów. Inteligentne czujniki przeszkód i doskonała stabilizacja. Punkt wyjścia do wszystkich kategorii." },
        { badge: "Foto-Video", desc: "Skupienie na nagrywaniu foto/video w wysokiej jakości. Kompatybilny z kontrolerami RC1 oraz goglami DJI Goggles 2." },
        { badge: "Szybkie FPV", desc: "Loty w goglach wirtualnej rzeczywistości (VR). Szybkie zakręty, dynamiczne ujęcia akcji i pełna immersja. Nauka od podstaw na DJI Neo." },
      ],
      safetyBold: "Bezpieczeństwo przede wszystkim.",
      safety: " Wszystkie drony szkoleniowe posiadają osłony śmigieł.",
    },
    about: {
      overline: "Kim jesteśmy?",
      title: "Poznajemy świat dronów razem",
      paragraph: "DRON to zespół pasjonatów i operatorów, którzy pokazują, jak bezpiecznie i odpowiedzialnie korzystać z dronów. Posiadamy uprawnienia A1/A3 i praktyczne doświadczenie — od ujęć z powietrza po codzienne przygotowanie do lotu.",
      points: [
        "Tylko sprawdzony sprzęt najwyższej jakości (DJI).",
        "Uprawnienia A1/A3 i nacisk na zasady bezpiecznego latania.",
        "Praktyczne spotkanie dopasowane do Twojego poziomu i pytań.",
      ],
      stats: [
        { value: "A1 / A3", label: "uprawnienia operatorów" },
        { value: "4× DJI Neo", label: "w pakiecie startowym" },
        { value: "12", label: "baterii + 4 huby ładowania" },
      ],
    },
    how: {
      overline: "Pierwsze spotkanie",
      title: "Jak wygląda pierwsze spotkanie?",
      steps: [
        { title: "Napisz do nas", text: "Zajmie to mniej niż minutę." },
        { title: "Ustal dogodny termin", text: "Skontaktujemy się z Tobą i ustalimy szczegóły." },
        { title: "Poznaj drona", text: "Nie musisz mieć własnego sprzętu." },
        { title: "Spróbuj pierwszego lotu 🚀", text: "Z osobą z uprawnieniami A1/A3 obok wykonasz pierwsze ćwiczenia." },
        { title: "Zdecyduj, co dalej", text: "Bez presji i żadnych zobowiązań." },
      ],
      cta: "Sprawdź, czy latanie dronem jest dla Ciebie →",
    },
    finalCta: {
      overline: "Gotowy na pierwsze spotkanie?",
      title: "Odkryj swój potencjał i umów pierwsze spotkanie.",
      text: "Zacznij od czterech krótkich pytań i sprawdź, jakie możliwości może otworzyć przed Tobą nauka bezpiecznego latania dronem.",
      cta: "Rozpocznij quiz →",
    },
    faq: {
      overline: "FAQ",
      title: "Najczęściej zadawane pytania",
      items: [
        { q: "Co jeśli uszkodzę drona podczas pierwszego spotkania?", a: "Spokojnie! Zaczynamy od bezpiecznych ćwiczeń i zasad odpowiedzialnego latania. Zakres spotkania ustalamy tak, aby dopasować go do Twojego doświadczenia." },
        { q: "Czy muszę mieć własnego drona?", a: "Nie. Na pierwsze spotkanie zapewniamy potrzebny sprzęt." },
        { q: "Od jakiego wieku można się zgłosić?", a: "To zależy od rodzaju spotkania i sytuacji. W przypadku osób niepełnoletnich prosimy o udział opiekuna." },
        { q: "Czy to bezpieczne?", a: "Tak. Zaczynamy od podstaw, omawiamy zasady i latamy odpowiedzialnie pod opieką osoby z odpowiednimi uprawnieniami A1/A3." },
        { q: "Jak długo trwa spotkanie?", a: "Pierwsze spotkanie trwa około 45 minut — wystarczająco długo, aby poznać sprzęt, zasady i wykonać pierwsze ćwiczenia." },
        { q: "Co mogę robić po nauczeniu się latać dronem?", a: "Możesz tworzyć zdjęcia i filmy, rozwijać nową umiejętność albo poznawać zastosowania dronów w biznesie, nieruchomościach i inspekcjach." },
      ],
    },
    form: {
      overline: "Zgłoszenie",
      title: "Umów pierwsze spotkanie",
      name: "Imię",
      phone: "Numer telefonu",
      email: "E-mail",
      telegram: "Telegram (opcjonalnie)",
      whatsapp: "WhatsApp (opcjonalnie)",
      required: "* Wymagany jest telefon, e-mail LUB Telegram (minimum jedno z trzech).",
      consentPre: "Klikając przycisk, akceptujesz ",
      consentLink: "politykę prywatności",
      submit: "Chcę poznać drony!",
      placeholders: { name: "Jan", phone: "+48 501 254 893", email: "jan@email.pl", telegram: "@nick", whatsapp: "+48..." },
      errors: { name: "Podaj imię.", contact: "Wymagany jest telefon, poprawny e-mail LUB Telegram.", phone: "Nieprawidłowy format telefonu E.164 (np. +48123456789).", email: "Nieprawidłowy adres e-mail.", consent: "Zaakceptuj politykę prywatności.", generic: "Coś poszło nie tak. Spróbuj ponownie." },
      successToast: "Zgłoszenie wysłane! Skontaktujemy się wkrótce.",
      successTitle: "Dziękujemy!",
      successText: "Twoje zgłoszenie zostało wysłane. Skontaktujemy się z Tobą, aby ustalić szczegóły pierwszego spotkania.",
      successAgain: "Wyślij kolejne zgłoszenie",
      scheduleTitle: "Ustal termin spotkania",
      scheduleButton: "Wybierz termin spotkania",
      scheduleInfoTitle: "ℹ️ Ważne informacje organizacyjne:",
      scheduleInfoItems: ["Spotkanie odbędzie się po zebraniu grupy minimum 6 osób.", "Ze względu na ograniczony czas decyduje kolejność zgłoszeń."],
      groupDatesTitle: "Sugerowane terminy grupowe:",
      scheduleSlots: ["Najbliższa sobota 10:00–12:00", "Najbliższa niedziela 14:00–16:00", "Najbliższa niedziela 16:00–18:00"],
      customDateTitle: "Lub wybierz własny termin:",
      preferredTime: "Preferowana godzina:",
      back: "Wstecz",
      scheduleSubmit: "Umów pierwsze spotkanie",
    },
    footer: {
      tagline: "DRON. Pokazujemy, jak latać bezpiecznie i odpowiedzialnie — na sprzęcie DJI, z praktycznym podejściem i uprawnieniami A1/A3.",
      contact: "Kontakt",
      company: "Dane firmy",
      privacy: "Polityka prywatności",
      rights: "Wszelkie prawa zastrzeżone.",
    },
    cookie: {
      text: "Używamy plików cookies, aby analizować ruch (Google Analytics) i ulepszać stronę. Analityka uruchamiana jest dopiero po Twojej zgodzie.",
      accept: "Akceptuję",
      decline: "Odrzuć",
    },
    privacy: {
      back: "Powrót na stronę główną",
      title: "Polityka prywatności",
      intro: "Niniejsza polityka prywatności określa zasady przetwarzania danych osobowych przekazanych przez Użytkowników w związku z korzystaniem ze strony dron.voxianet.com prowadzonej przez Voxia sp. z o.o.",
      sections: [
        { h: "1. Administrator danych", p: "Administratorem danych osobowych jest Voxia sp. z o.o. z siedzibą w Warszawie (ul. Władysława Pytlasińskiego 16/13, 00-777 Warszawa)." },
        { h: "2. Zakres i cel przetwarzania", p: "Dane podane w formularzu kontaktowym (imię, numer telefonu, e-mail, Telegram, WhatsApp) przetwarzane są wyłącznie w celu kontaktu i umówienia pierwszego spotkania poświęconego bezpiecznemu lataniu dronem." },
        { h: "3. Pliki cookies i analityka", p: "Strona wykorzystuje pliki cookies oraz narzędzie Google Analytics 4. Analityka uruchamiana jest dopiero po wyrażeniu przez Użytkownika zgody w bannerze cookies." },
        { h: "4. Prawa Użytkownika", p: "Użytkownik ma prawo dostępu do swoich danych, ich sprostowania, usunięcia lub ograniczenia przetwarzania, a także prawo do wniesienia sprzeciwu i skargi do organu nadzorczego." },
        { h: "5. Kontakt", p: "W sprawach dotyczących danych osobowych prosimy o kontakt: kontakt@voxianet.com." },
      ],
    },
  },

  en: {
    nav: { quiz: "Quiz", offer: "Opportunities", fleet: "Fleet", about: "About", how: "How it works", faq: "FAQ" },
    header: { descriptor: "Practical drone sessions", cta: "Take the quiz", ctaFull: "Find out if flying a drone is right for you" },
    hero: {
      overline: "DRON • learn to fly safely",
      title: "Learn to fly a drone and discover new opportunities 🚀",
      subtitle: "During your first meeting, you’ll see what safe drone control looks like and where to start — even if you’ve never held a controller before.",
      cta: "Find out if flying a drone is right for you →",
      channelCta: "Join our channel to see when the next free-flying event is announced",
      badges: ["Starting from zero", "You don’t need your own drone", "A1/A3 qualifications and safety first"],
      scroll: "Scroll to opportunities",
    },
    opportunities: {
      overline: "More than a first flight",
      title: "What can you gain by learning to fly a drone?",
      intro: "One new skill can open a completely new perspective — for creativity, confidence and your future.",
      cards: [
        { id: "create", title: "CREATE", text: "Capture photos and videos from a completely new perspective. Learn to create spectacular aerial content that isn’t possible with a regular camera." },
        { id: "grow", title: "GROW", text: "Gain a skill for the future. Drone technology is being used across an increasing number of industries — from video production to inspections and surveying." },
        { id: "professional", title: "USE IT PROFESSIONALLY", text: "Discover new career opportunities. Explore different ways drones can be used in work, business and creative projects." },
        { id: "experience", title: "EXPERIENCE SOMETHING NEW", text: "Feel the excitement of your first independent flight. You don’t need any experience — start from zero with a qualified operator beside you." },
      ],
    },
    confidence: {
      overline: "No barriers at the start",
      title: "You don’t need anything to get started",
      items: [
        { id: "beginner", title: "Never flown before?", text: "We start from the basics." },
        { id: "equipment", title: "No drone?", text: "We provide all the equipment." },
        { id: "safety", title: "Afraid of crashing?", text: "A qualified operator is beside you during the first exercises." },
        { id: "rules", title: "Don’t know the rules?", text: "We’ll show you how to fly safely and responsibly." },
      ],
    },
    quiz: {
      overline: "Quick quiz",
      title: "Is drone piloting right for you?",
      subtitle: "Answer 4 quick questions and discover what you could achieve by learning to fly a drone. At the end, see what your first meeting could look like.",
      start: "Start the quiz →",
      back: "Back",
      next: "Next question →",
      restart: "Start again",
      progress: "Question",
      questions: [
        { id: "motivation", title: "Why do you want to learn to fly a drone?", options: [
          { id: "try", text: "I want to try something new" },
          { id: "content", text: "I want to create aerial photos and videos" },
          { id: "career", text: "I want to gain a useful skill for my career" },
          { id: "explore", text: "I’m not sure yet — I just want to explore" },
        ] },
        { id: "experience", title: "Have you ever flown a drone before?", options: [
          { id: "never", text: "Never" },
          { id: "few", text: "A few times" },
          { id: "improve", text: "Yes, but I want to improve" },
        ] },
        { id: "barrier", title: "What is holding you back the most?", options: [
          { id: "crash", text: "I’m afraid of crashing the drone" },
          { id: "control", text: "I don’t know how to control it" },
          { id: "rules", text: "I don’t understand the rules and regulations" },
          { id: "doubt", text: "I’m not sure if I can do it" },
        ] },
        { id: "outcome", title: "What would you like to achieve with this skill?", options: [
          { id: "content", text: "Create amazing video content" },
          { id: "confidence", text: "Learn to fly confidently" },
          { id: "career", text: "Gain a modern professional skill" },
          { id: "experience", text: "Simply experience something exciting and new" },
        ] },
      ],
      result: {
        overline: "Your result",
        intro: "Based on your answers, we’ve identified the best first step for you.",
        benefits: ["Learn the basics of drone control", "Complete your first flying exercises", "Discover that you can learn to fly from scratch", "Find out what opportunities this skill can open for you"],
        firstMeeting: "Your first meeting helps you decide what comes next.",
        profiles: {
          create: { title: "You could create something truly different 🚀", text: "Drone piloting can turn your ideas into views and stories that stand out." },
          career: { title: "This skill could open new career opportunities 💼", text: "You can explore how drones support work in media, marketing, property and many other industries." },
          confidence: { title: "You can learn to fly with confidence 🧠", text: "The right guidance helps you replace uncertainty with safe, responsible control." },
          explore: { title: "Drone piloting could be a perfect new experience 🔥", text: "A first flight is a simple way to discover a skill you may want to develop further." },
        },
      },
      form: {
        title: "Book your first meeting",
        name: "Name",
        contact: "Phone or Telegram",
        city: "City",
        consentPre: "I agree to the ",
        consentLink: "privacy policy",
        placeholderName: "Your name",
        placeholderContact: "+48 501 254 893 or @username",
        placeholderCity: "Warsaw",
        submit: "🔥 Book my first meeting",
        sending: "Sending…",
        successTitle: "Your first step is booked!",
        successText: "We’ll contact you soon to arrange the details of your first meeting.",
        error: "Something went wrong. Please try again.",
        validation: { name: "Enter your name.", contact: "Enter a phone number or Telegram handle.", city: "Enter your city.", consent: "Please accept the privacy policy.", turnstile: "Complete the security check." },
      },
    },
    offer: {
      overline: "Your first meeting",
      title: "See what flying a drone is really like",
      intro: "During your first meeting, we’ll show you the basics of safe control and answer your questions about developing the skill further.",
      badgeTop: "A1 / A3",
      badgeBottom: "safety first",
      items: [
        { title: "Safety basics", text: "Learn the key rules for responsible flying and preparing for take-off." },
        { title: "Meet the equipment", text: "See how the controller works and how to prepare a drone for flight." },
        { title: "First exercises", text: "Try basic maneuvers and a calm landing with a qualified operator beside you." },
        { title: "What comes next?", text: "Talk through ways to develop your skills and use drones in practice." },
      ],
    },
    fleet: {
      overline: "Our fleet",
      title: "What we fly: our equipment",
      cards: [
        { badge: "Recreational", desc: "Perfect to start your drone adventure. Control with gestures, phone or DJI controllers. Great for travel and vlogs. Smart obstacle sensors and excellent stabilization. A gateway to every category." },
        { badge: "Photo-Video", desc: "Focused on high-quality photo/video recording. Compatible with RC1 controllers and DJI Goggles 2." },
        { badge: "Fast FPV", desc: "Flights in virtual reality (VR) goggles. Fast turns, dynamic action shots and full immersion. Learn from scratch on the DJI Neo." },
      ],
      safetyBold: "Safety first.",
      safety: " All training drones have propeller guards.",
    },
    about: {
      overline: "Who are we?",
      title: "Discover the world of drones with us",
      paragraph: "DRON is a team of drone enthusiasts and operators who show how to fly safely and responsibly. We hold A1/A3 qualifications and bring practical experience — from aerial shots to everyday flight preparation.",
      points: [
        "Only proven, top-quality equipment (DJI).",
        "A1/A3 qualifications and a focus on safe flying rules.",
        "A practical meeting shaped around your level and questions.",
      ],
      stats: [
        { value: "A1 / A3", label: "operator qualifications" },
        { value: "4× DJI Neo", label: "in the starter kit" },
        { value: "12", label: "batteries + 4 charging hubs" },
      ],
    },
    how: {
      overline: "Your first meeting",
      title: "How does your first meeting work?",
      steps: [
        { title: "Message us", text: "It takes less than one minute." },
        { title: "Choose a convenient time", text: "We contact you and arrange the details." },
        { title: "Meet the drone", text: "You don’t need to own any equipment." },
        { title: "Try your first flight 🚀", text: "With a qualified A1/A3 operator beside you, you’ll complete your first exercises." },
        { title: "Decide what happens next", text: "No pressure and no obligation." },
      ],
      cta: "Find out if flying a drone is right for you →",
    },
    finalCta: {
      overline: "Ready for your first meeting?",
      title: "Discover your potential and book your first meeting.",
      text: "Start with four quick questions and discover what opportunities learning to fly a drone could open for you.",
      cta: "Start the quiz →",
    },
    faq: {
      overline: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "What if I damage the drone during my first meeting?", a: "No worries. We start with safe exercises and responsible flying rules, adapting the meeting to your experience." },
        { q: "Do I need my own drone?", a: "No. We provide the equipment needed for your first meeting." },
        { q: "What is the minimum age to get in touch?", a: "It depends on the meeting format and circumstances. Minors should take part with a guardian." },
        { q: "Is it safe?", a: "Yes. We start with the basics, discuss the rules and fly responsibly with a qualified A1/A3 operator beside you." },
        { q: "How long is the meeting?", a: "The first meeting takes about 45 minutes — enough time to meet the equipment, discuss the rules and complete your first exercises." },
        { q: "What can I do after learning to fly a drone?", a: "You can create photos and videos, develop a new skill or explore drone applications in business, property and inspections." },
      ],
    },
    form: {
      overline: "Request",
      title: "Book your first meeting",
      name: "Name",
      phone: "Phone number",
      email: "E-mail",
      telegram: "Telegram (optional)",
      whatsapp: "WhatsApp (optional)",
      required: "* Phone, e-mail OR Telegram is required (at least one of the three).",
      consentPre: "By clicking the button, you accept the ",
      consentLink: "privacy policy",
      submit: "I want to explore drones!",
      placeholders: { name: "John", phone: "+48 501 254 893", email: "john@email.com", telegram: "@nick", whatsapp: "+48..." },
      errors: { name: "Enter your name.", contact: "Phone, a valid e-mail OR Telegram is required.", phone: "Invalid E.164 phone number format (e.g. +48123456789).", email: "Invalid e-mail address.", consent: "Please accept the privacy policy.", generic: "Something went wrong. Please try again." },
      successToast: "Request sent! We'll contact you soon.",
      successTitle: "Thank you!",
      successText: "Your request has been sent. We'll contact you to arrange your first meeting.",
      successAgain: "Send another request",
      scheduleTitle: "Arrange your meeting",
      scheduleButton: "Choose a meeting time",
      scheduleInfoTitle: "ℹ️ Important organisational information:",
      scheduleInfoItems: ["The meeting takes place once a group of at least 6 people has formed.", "Because places are limited, requests are handled in order of submission."],
      groupDatesTitle: "Suggested group times:",
      scheduleSlots: ["Next Saturday 10:00–12:00", "Next Sunday 14:00–16:00", "Next Sunday 16:00–18:00"],
      customDateTitle: "Or choose your own time:",
      preferredTime: "Preferred time:",
      back: "Back",
      scheduleSubmit: "Book the first meeting",
    },
    footer: {
      tagline: "DRON. We show you how to fly safely and responsibly — with DJI equipment, practical guidance and A1/A3 qualifications.",
      contact: "Contact",
      company: "Company details",
      privacy: "Privacy policy",
      rights: "All rights reserved.",
    },
    cookie: {
      text: "We use cookies to analyze traffic (Google Analytics) and improve the site. Analytics is only enabled after your consent.",
      accept: "Accept",
      decline: "Decline",
    },
    privacy: {
      back: "Back to homepage",
      title: "Privacy policy",
      intro: "This privacy policy sets out the rules for processing personal data provided by Users in connection with the use of the dron.voxianet.com website operated by Voxia sp. z o.o.",
      sections: [
        { h: "1. Data controller", p: "The controller of personal data is Voxia sp. z o.o., based in Warsaw (ul. Władysława Pytlasińskiego 16/13, 00-777 Warsaw)." },
        { h: "2. Scope and purpose of processing", p: "The data provided in the contact form (name, phone number, e-mail, Telegram, WhatsApp) is processed solely to contact you and arrange a first meeting focused on safe drone flying." },
        { h: "3. Cookies and analytics", p: "The site uses cookies and Google Analytics 4. Analytics is only enabled after the User gives consent in the cookie banner." },
        { h: "4. User rights", p: "The User has the right to access their data, rectify, delete or restrict its processing, as well as the right to object and to lodge a complaint with the supervisory authority." },
        { h: "5. Contact", p: "For matters regarding personal data, please contact: kontakt@voxianet.com." },
      ],
    },
  },

  ru: {
    nav: { quiz: "Квиз", offer: "Возможности", fleet: "Парк", about: "О нас", how: "Как это работает", faq: "FAQ" },
    header: { descriptor: "Практические встречи с дронами", cta: "Пройди квиз", ctaFull: "Узнай, подходят ли тебе полёты на дроне" },
    hero: {
      overline: "DRON • безопасные полёты",
      title: "Научись летать на дроне и открой новые возможности 🚀",
      subtitle: "На первой встрече ты увидишь, как выглядит безопасное управление дроном и с чего начать — даже если никогда не держал пульт в руках.",
      cta: "Узнай, подходят ли тебе полёты на дроне →",
      channelCta: "Присоединяйся к нашему каналу и следи за анонсом следующего события с бесплатными полётами",
      badges: ["Начинаешь с нуля", "Свой дрон не нужен", "Допуски A1/A3 и безопасность"],
      scroll: "К возможностям",
    },
    opportunities: {
      overline: "Больше, чем первый полёт",
      title: "Что ты получишь, научившись летать на дроне?",
      intro: "Один новый навык может открыть совершенно новый взгляд на мир — для творчества, уверенности и будущего.",
      cards: [
        { id: "create", title: "СОЗДАВАЙ", text: "Снимай фото и видео с совершенно новой точки зрения. Научись создавать эффектные кадры с воздуха, невозможные для обычной камеры." },
        { id: "grow", title: "РАЗВИВАЙСЯ", text: "Получи навык будущего. Дроны используют во всё большем числе отраслей — от видеопроизводства до инспекций и измерений." },
        { id: "professional", title: "ИСПОЛЬЗУЙ В РАБОТЕ", text: "Открой новые карьерные возможности. Узнай, как применять дроны в работе, бизнесе и творческих проектах." },
        { id: "experience", title: "ПОПРОБУЙ НОВОЕ", text: "Почувствуй эмоции первого самостоятельного полёта. Опыт не нужен — начнёшь с нуля, а квалифицированный оператор будет рядом." },
      ],
    },
    confidence: {
      overline: "Без барьеров на старте",
      title: "Тебе ничего не нужно, чтобы начать",
      items: [
        { id: "beginner", title: "Никогда не летал?", text: "Начнём с основ." },
        { id: "equipment", title: "Нет дрона?", text: "Мы предоставим всё оборудование." },
        { id: "safety", title: "Боишься разбить?", text: "Квалифицированный оператор будет рядом во время первых упражнений." },
        { id: "rules", title: "Не знаешь правила?", text: "Покажем, как летать безопасно и ответственно." },
      ],
    },
    quiz: {
      overline: "Быстрый квиз",
      title: "Подходит ли тебе пилотирование дронов?",
      subtitle: "Ответь на 4 коротких вопроса и узнай, чего ты можешь достичь, научившись летать на дроне. В конце ты увидишь, как может пройти первая встреча.",
      start: "Начать квиз →",
      back: "Назад",
      next: "Следующий вопрос →",
      restart: "Начать заново",
      progress: "Вопрос",
      questions: [
        { id: "motivation", title: "Почему ты хочешь научиться летать на дроне?", options: [
          { id: "try", text: "Хочу попробовать что-то новое" },
          { id: "content", text: "Хочу создавать фото и видео с воздуха" },
          { id: "career", text: "Хочу получить полезный навык для карьеры" },
          { id: "explore", text: "Пока не знаю — хочу просто разобраться" },
        ] },
        { id: "experience", title: "Ты когда-нибудь уже летал на дроне?", options: [
          { id: "never", text: "Никогда" },
          { id: "few", text: "Несколько раз" },
          { id: "improve", text: "Да, но хочу улучшить свои навыки" },
        ] },
        { id: "barrier", title: "Что больше всего тебя останавливает?", options: [
          { id: "crash", text: "Боюсь разбить дрон" },
          { id: "control", text: "Не знаю, как им управлять" },
          { id: "rules", text: "Не понимаю правила и законы" },
          { id: "doubt", text: "Не уверен, что у меня получится" },
        ] },
        { id: "outcome", title: "Чего ты хочешь достичь с помощью этого навыка?", options: [
          { id: "content", text: "Создавать потрясающий видеоконтент" },
          { id: "confidence", text: "Научиться летать уверенно" },
          { id: "career", text: "Получить современный профессиональный навык" },
          { id: "experience", text: "Просто испытать что-то захватывающее и новое" },
        ] },
      ],
      result: {
        overline: "Твой результат",
        intro: "По твоим ответам мы определили лучший первый шаг для тебя.",
        benefits: ["Освоишь основы управления дроном", "Выполнишь первые упражнения в полёте", "Убедишься, что можно научиться летать с нуля", "Узнаешь, какие возможности открывает этот навык"],
        firstMeeting: "Первая встреча поможет решить, что делать дальше.",
        profiles: {
          create: { title: "Ты можешь создавать действительно необычные вещи 🚀", text: "Пилотирование дронов поможет превращать идеи в кадры и истории, которые выделяются." },
          career: { title: "Этот навык может открыть новые карьерные возможности 💼", text: "Ты узнаешь, как дроны помогают в медиа, маркетинге, недвижимости и многих других сферах." },
          confidence: { title: "Ты можешь научиться летать уверенно 🧠", text: "Правильная поддержка поможет заменить сомнения безопасным и ответственным управлением." },
          explore: { title: "Пилотирование дронов может стать отличным новым опытом 🔥", text: "Первый полёт — простой способ открыть навык, который захочется развивать дальше." },
        },
      },
      form: {
        title: "Запишись на первую встречу",
        name: "Имя",
        contact: "Телефон или Telegram",
        city: "Город",
        consentPre: "Я принимаю ",
        consentLink: "политику конфиденциальности",
        placeholderName: "Твоё имя",
        placeholderContact: "+48 501 254 893 или @username",
        placeholderCity: "Варшава",
        submit: "🔥 Записаться на встречу",
        sending: "Отправляем…",
        successTitle: "Твой первый шаг забронирован!",
        successText: "Мы скоро свяжемся с тобой, чтобы согласовать детали первой встречи.",
        error: "Что-то пошло не так. Попробуй ещё раз.",
        validation: { name: "Укажи имя.", contact: "Укажи номер телефона или имя пользователя Telegram.", city: "Укажи город.", consent: "Прими политику конфиденциальности.", turnstile: "Пройди проверку безопасности." },
      },
    },
    offer: {
      overline: "Первая встреча",
      title: "Узнай, как проходят полёты на дроне",
      intro: "На первой встрече мы покажем основы безопасного управления и ответим на вопросы о дальнейшем развитии навыка.",
      badgeTop: "A1 / A3",
      badgeBottom: "безопасность прежде всего",
      items: [
        { title: "Основы безопасности", text: "Узнаешь главные правила ответственных полётов и подготовки к старту." },
        { title: "Знакомство с оборудованием", text: "Увидишь, как работает пульт и как подготовить дрон к полёту." },
        { title: "Первые упражнения", text: "Попробуешь базовые манёвры и спокойную посадку рядом с квалифицированным оператором." },
        { title: "Что дальше?", text: "Обсудим, как развивать навыки и применять дроны на практике." },
      ],
    },
    fleet: {
      overline: "Наш парк",
      title: "На чём мы летаем: наше оборудование",
      cards: [
        { badge: "Рекреационные", desc: "Идеально для начала знакомства с дронами. Управление жестами, телефоном или пультами DJI. Отлично для путешествий и влогов. Умные датчики препятствий и отличная стабилизация. Старт для всех категорий." },
        { badge: "Фото-Видео", desc: "Упор на съёмку фото/видео высокого качества. Совместим с пультами RC1 и очками DJI Goggles 2." },
        { badge: "Быстрые FPV", desc: "Полёты в очках виртуальной реальности (VR). Резкие повороты, динамичные экшн-кадры и полное погружение. Обучение с нуля на DJI Neo." },
      ],
      safetyBold: "Безопасность прежде всего.",
      safety: " Все учебные дроны оснащены защитой винтов.",
    },
    about: {
      overline: "Кто мы?",
      title: "Вместе знакомимся с миром дронов",
      paragraph: "DRON — команда энтузиастов и операторов, которые показывают, как летать безопасно и ответственно. У нас есть допуски A1/A3 и практический опыт — от воздушных съёмок до ежедневной подготовки к полёту.",
      points: [
        "Только проверенное оборудование высшего качества (DJI).",
        "Допуски A1/A3 и внимание к правилам безопасных полётов.",
        "Практическая встреча под твой уровень и вопросы.",
      ],
      stats: [
        { value: "A1 / A3", label: "допуски операторов" },
        { value: "4× DJI Neo", label: "в стартовом комплекте" },
        { value: "12", label: "батарей + 4 зарядных хаба" },
      ],
    },
    how: {
      overline: "Первая встреча",
      title: "Как проходит первая встреча?",
      steps: [
        { title: "Напиши нам", text: "Это займёт меньше минуты." },
        { title: "Выбери удобное время", text: "Мы свяжемся с тобой и договоримся о деталях." },
        { title: "Познакомься с дроном", text: "Своё оборудование иметь не нужно." },
        { title: "Попробуй первый полёт 🚀", text: "Квалифицированный оператор с допуском A1/A3 будет рядом во время первых упражнений." },
        { title: "Реши, что дальше", text: "Без давления и обязательств." },
      ],
      cta: "Узнай, подходят ли тебе полёты на дроне →",
    },
    finalCta: {
      overline: "Готов к первой встрече?",
      title: "Открой свой потенциал и запишись на первую встречу.",
      text: "Начни с четырёх коротких вопросов и узнай, какие возможности может открыть обучение безопасным полётам на дроне.",
      cta: "Начать квиз →",
    },
    faq: {
      overline: "FAQ",
      title: "Часто задаваемые вопросы",
      items: [
        { q: "Что если я поврежу дрон во время первой встречи?", a: "Спокойно! Мы начинаем с безопасных упражнений и правил ответственных полётов. Содержание встречи подбирается с учётом твоего опыта." },
        { q: "Нужен ли мне собственный дрон?", a: "Нет. На первую встречу мы предоставим необходимое оборудование." },
        { q: "С какого возраста можно обратиться?", a: "Это зависит от формата встречи и ситуации. Несовершеннолетним потребуется участие сопровождающего." },
        { q: "Это безопасно?", a: "Да. Мы начинаем с основ, обсуждаем правила и летаем ответственно рядом с оператором с допусками A1/A3." },
        { q: "Сколько длится встреча?", a: "Первая встреча длится около 45 минут — этого достаточно, чтобы познакомиться с оборудованием, правилами и выполнить первые упражнения." },
        { q: "Что я смогу делать после обучения?", a: "Ты сможешь создавать фото и видео, развивать новый навык или изучать применение дронов в бизнесе, недвижимости и инспекциях." },
      ],
    },
    form: {
      overline: "Заявка",
      title: "Запишись на первую встречу",
      name: "Имя",
      phone: "Номер телефона",
      email: "E-mail",
      telegram: "Telegram (необязательно)",
      whatsapp: "WhatsApp (необязательно)",
      required: "* Требуется телефон, e-mail ИЛИ Telegram (минимум одно из трёх).",
      consentPre: "Нажимая кнопку, ты принимаешь ",
      consentLink: "политику конфиденциальности",
      submit: "Хочу познакомиться с дронами!",
      placeholders: { name: "Иван", phone: "+48 501 254 893", email: "ivan@email.com", telegram: "@nick", whatsapp: "+48..." },
      errors: { name: "Укажите имя.", contact: "Требуется телефон, корректный e-mail ИЛИ Telegram.", phone: "Неверный формат телефона E.164 (напр. +48123456789).", email: "Неверный адрес e-mail.", consent: "Примите политику конфиденциальности.", generic: "Что-то пошло не так. Попробуйте снова." },
      successToast: "Заявка отправлена! Мы скоро свяжемся с тобой.",
      successTitle: "Спасибо!",
      successText: "Твоя заявка отправлена. Мы свяжемся с тобой, чтобы согласовать детали первой встречи.",
      successAgain: "Отправить ещё одну заявку",
      scheduleTitle: "Согласуй встречу",
      scheduleButton: "Выбрать время встречи",
      scheduleInfoTitle: "ℹ️ Важная организационная информация:",
      scheduleInfoItems: ["Встреча состоится после формирования группы минимум из 6 человек.", "Из-за ограниченного количества мест заявки обрабатываются по очереди."],
      groupDatesTitle: "Предлагаемые групповые сроки:",
      scheduleSlots: ["Ближайшая суббота 10:00–12:00", "Ближайшее воскресенье 14:00–16:00", "Ближайшее воскресенье 16:00–18:00"],
      customDateTitle: "Или выбери своё время:",
      preferredTime: "Предпочтительное время:",
      back: "Назад",
      scheduleSubmit: "Записаться на первую встречу",
    },
    footer: {
      tagline: "DRON. Показываем, как летать безопасно и ответственно — на оборудовании DJI, с практическим подходом и допусками A1/A3.",
      contact: "Контакты",
      company: "Реквизиты компании",
      privacy: "Политика конфиденциальности",
      rights: "Все права защищены.",
    },
    cookie: {
      text: "Мы используем файлы cookie для анализа трафика (Google Analytics) и улучшения сайта. Аналитика включается только после твоего согласия.",
      accept: "Принимаю",
      decline: "Отклонить",
    },
    privacy: {
      back: "Вернуться на главную",
      title: "Политика конфиденциальности",
      intro: "Настоящая политика конфиденциальности определяет правила обработки персональных данных, предоставленных Пользователями в связи с использованием сайта dron.voxianet.com, управляемого Voxia sp. z o.o.",
      sections: [
        { h: "1. Администратор данных", p: "Администратором персональных данных является Voxia sp. z o.o. с местонахождением в Варшаве (ul. Władysława Pytlasińskiego 16/13, 00-777 Варшава)." },
        { h: "2. Объём и цель обработки", p: "Данные, указанные в контактной форме (имя, номер телефона, e-mail, Telegram, WhatsApp), обрабатываются исключительно для связи и согласования первой встречи, посвящённой безопасным полётам на дроне." },
        { h: "3. Файлы cookie и аналитика", p: "Сайт использует файлы cookie и инструмент Google Analytics 4. Аналитика включается только после согласия Пользователя в баннере cookie." },
        { h: "4. Права Пользователя", p: "Пользователь имеет право на доступ к своим данным, их исправление, удаление или ограничение обработки, а также право на возражение и подачу жалобы в надзорный орган." },
        { h: "5. Контакт", p: "По вопросам персональных данных обращайтесь: kontakt@voxianet.com." },
      ],
    },
  },
};
